/* Closes the Zepto personalizer popup after the item is added to the
   cart. The app is set to hand the add off to the theme's own product
   form (Zepto "after add" mode 4) and leaves its popup open; the theme
   publishes cartUpdate right after that add succeeds, just before it
   opens the cart drawer, so that is when we close the popup.

   Products with a separate personalization fee product make the app
   fire its own /cart/add.js call first, so a request-based trigger would
   start closing the popup while the app still needs it. The pubsub
   event only fires for the theme form, so it is the primary trigger;
   the fetch/XHR watch below is a fallback for when pubsub is missing.

   Call pplr_w_h() directly rather than clicking the popup's close link:
   a synthetic click bubbles to document.body, where the theme's
   cart-notification closes the drawer it just opened, and the app's
   document click handler clears its pplr_atc_triggered flag, which
   makes its cart sync rewrite the fee lines and reload the page. */
(function () {
  function closePopup() {
    if (typeof window.pplr_w_h !== 'function') return;
    if (!document.querySelector('.pplr-modal-overlay')) return;
    try {
      window.pplr_w_h();
    } catch (err) {
      /* popup already gone; nothing to do */
    }
  }

  var hasPubSub =
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined' &&
    PUB_SUB_EVENTS.cartUpdate;

  if (hasPubSub) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      if (data && data.source === 'product-form') closePopup();
    });
    return;
  }

  function isCartAdd(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartAdd(url)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) setTimeout(closePopup, 300);
      });
    }
    return originalOpen.apply(this, arguments);
  };

  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : input && input.url;
      var result = originalFetch.apply(this, arguments);
      if (isCartAdd(url)) {
        result
          .then(function (response) {
            if (response && response.ok) setTimeout(closePopup, 300);
          })
          .catch(function () {});
      }
      return result;
    };
  }
})();
